import React, { useState } from 'react';
import { initialValuesOfCreateTickets, validationSchemaOfCreateTickets } from 'components/support/utils';
import { Formik } from 'formik';
import Loading from 'components/common/loading/Loading';
import { useMutation, useQuery } from 'react-query';
import { CREATE_TICKET } from 'components/support/queries';
import { CustomHook } from 'utils/custom-hook';
import CreateTicket from './CreateTicket';
import { useEditor } from '@wysimark/react';
import {Remarkable} from 'remarkable';
import { useHistory } from 'react-router-dom';

const CreateTicketContainer = () => {
  const md = new Remarkable();
  const { mutationProps } = CustomHook();
  const [userData, setUserData] = useState({});
  const [searchMacro, setSearchMacro] = useState('');
  const [macroData, setMacroData] = useState({});
  const { data: ticketDepartment, isLoading: depLoading } = useQuery('/admin/tickets/departments');
  const { data: ticketDepName, isLoading: depNameLoading } = useQuery('/admin/tickets/department/definitions');
  const { mutate: createTicket, isLoading: loadingCreateTicket } = useMutation(CREATE_TICKET);
  const editor = useEditor({ initialMarkdown: '', minHeight: 480 });
  let history = useHistory();

  const handleSubmitTicket = async (values, resetForm) => {
    await createTicket(
      {
        nonbillingcontacts: values.emailID === 'nonbillingcontacts' ? '1' : '0',
        billingcontacts: values.emailID === 'billingcontacts' ? '1' : '0',
        allcontacts: values.emailID === 'allcontacts' ? '1' : '0',
        username: values.username,
        dept: values.dept,
        subject: btoa(values.subject),
        message: btoa(values.message),
        note: btoa(values.note),
        secret: btoa(values.secret),
        messagehtml: btoa(md.render(values.message)),
      },
      mutationProps(() => {}, {
        onSuccess: () => {
          resetForm();
          // editor.resetMarkdown();
          setUserData({});
          setMacroData({});
          setSearchMacro('');
          history.push('/admin/tickets');
        },
      }),
    );
  };

  if (depLoading && depNameLoading) {
    <Loading />;
  }
  return (
    <Formik
      initialValues={initialValuesOfCreateTickets}
      validationSchema={validationSchemaOfCreateTickets}
      onSubmit={(values, { resetForm }) => handleSubmitTicket(values, resetForm)}
    >
      {(formikProp) => (
        <CreateTicket
          formikProp={formikProp}
          userData={userData}
          setUserData={setUserData}
          ticketDepartment={ticketDepartment}
          ticketDepName={ticketDepName}
          searchMacro={searchMacro}
          macroData={macroData}
          setSearchMacro={setSearchMacro}
          setMacroData={setMacroData}
          loadingCreateTicket={loadingCreateTicket}
          editor={editor}
        />
      )}
    </Formik>
  );
};
export default CreateTicketContainer;
